<template>
    <div
        class="overlay overlay--ice-beam"
        :style="{
            marginTop: returnLogobarHeight,
        }"
    >
        <div
            class="overlay__background"
            @click="handleClose"
        ></div>

        <div
            v-if="content.closeable.value"
            class="overlay__close"
            @click="handleClose"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 16.2 16.2"
                enable-background="new 0 0 16.2 16.2"
                xml:space="preserve"
            >
                <polygon
                    :fill="content.style.closeIconColor.value"
                    points="16.2,2.4 13.8,0 8.1,5.7 2.4,0 0,2.4 5.7,8.1 0,13.8 2.4,16.2 8.1,10.5 13.8,16.2 16.2,13.8 10.5,8.1 "
                />
            </svg>
        </div>

        <div
            ref="overlay"
            class="overlay__inner"
        >
            <zoe-atom-media
                class="overlay__media"
                :item="content.media.value"
            />

            <Transition
                name="step-transition"
                @before-leave="beforeLeave"
                @enter="onEnter"
            >
                <step-questions
                    v-if="$store.state.page.step === quizStep"
                    :content="get(`${step}.quiz`)"
                    :step="step"
                />
                <step-form
                    v-else-if="$store.state.page.step === formStep"
                    :content="get(`${step}.form`)"
                />
            </Transition>
        </div>
    </div>
</template>

<script>
import ZoeAtomMedia from '@atoms/media/v1.0.0/zoe-atom-media.vue';
import ZoeAtomText from '@atoms/text/v1.0.0/zoe-atom-text.vue';
// json5-ignore
import StepQuestions from '../questions/step-questions.vue';
// json5-ignore
import StepForm from '../form/step-form.vue';
import Component from '../../../../../../resources/mixins/component/component.vue';
import Step from '../../../../../../resources/mixins/step/step.vue';
import Buttons from '../../../../../../resources/mixins/quiz/buttons.vue';
import convertSize from '../../../../../../resources/mixins/utils/convert-size';

export default {
    components: {
        ZoeAtomText,
        ZoeAtomMedia,
        StepQuestions,
        StepForm,
    },

    mixins: [Component, Buttons, Step],

    emits: ['closeOverlay', 'overlayPreviewIsActive'],

    props: {
        quizStep: {
            type: Number,
            required: true,
        },

        formStep: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            isMediaLoaded: false,
        };
    },

    computed: {
        deviceType() {
            return this.$store.state.page.deviceType;
        },

        logobarHeight() {
            return this.$store.getters['component/getOrganismValue']('logobar', 'height');
        },

        returnLogobarHeight() {
            if (this.deviceType === 'desktop') {
                return `-${this.logobarHeight}px`;
            } else {
                return `-${convertSize(this.logobarHeight)}`;
            }
        },
    },

    watch: {
        isMediaLoaded() {
            if (this.isMediaLoaded) {
                this.$store.commit('component/setTemplateValue', {
                    component: 'overlay',
                    object: {
                        mounted: true,
                        height: this.$refs.overlay.clientHeight,
                    },
                });
            }
        },
    },

    methods: {
        handleClose() {
            if (this.content.closeable.value) {
                this.$emit('closeOverlay');
            }
        },
    },

    created() {
        const overlayPreview = this.getValue(`${this.step}.overlay.preview`);

        if (overlayPreview) {
            this.$emit('overlayPreviewIsActive');
        }
    },
};
</script>

<style lang="scss" scoped>
@use "step-overlay";

@layer step {
    .overlay {
        --background: v-bind('content.style.background.value');
        --close-icon-color: v-bind('content.style.closeIconColor.value')
    }
}

.step-transition-leave-active {
    transition: all .3s ease;
}

.step-transition-enter-active {
    transition: all .3s ease .3s;
}

.step-transition-leave-to,
.step-transition-enter-from {
    opacity: 0;
}
</style>
